import type { components } from '@trackercop/contracts';
import { HealthTile } from './health-tile';

type ComponentHealth = components['schemas']['ComponentHealth'];

interface HealthTileGridProps {
  components: ComponentHealth[];
}

export function HealthTileGrid({ components }: HealthTileGridProps) {
  if (components.length === 0) {
    return (
      <div
        className="rounded-md border bg-background p-6 text-sm text-muted-foreground"
        data-testid="health-tile-grid-empty"
      >
        No component health data yet — wait for the next probe cycle.
      </div>
    );
  }
  return (
    <div
      className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
      data-testid="health-tile-grid"
    >
      {components.map((c) => (
        <HealthTile key={c.name} component={c} />
      ))}
    </div>
  );
}
